import { styled } from '@mui/material/styles'
import Stack from '@mui/material/Stack'
import LinearProgress, {
  linearProgressClasses
} from '@mui/material/LinearProgress'
import { Translation } from 'react-i18next'
import { withStyles } from '@material-ui/core/styles'
import mobileView from '../../utils/mobile.utils'

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 20,
  borderRadius: 50,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: 'rgb(175 220 223)',
    ...(theme.palette.mode === 'dark' && {
      backgroundColor: 'rgb(175 220 223)'
    })
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 50,
    backgroundColor: '#44C0CC',
    ...(theme.palette.mode === 'dark' && {
      backgroundColor: '#44C0CC'
    })
  }
}))

const styles = () => ({
  button: {
    height: '45px',
    fontWeight: '600',
    fontSize: '16px'
  }
})

const MultiStepProgress = ({ step, totalSteps }) => {
  const progress = Math.round((step / totalSteps) * 100)

  return (
    <Translation>
      {(t) => (
        <div style={{ margin: '5px 20px 20px' }}>
          <Stack spacing={0.5} sx={{ flexGrow: 1 }}>
            <p style={{ margin: '0' }}>
              {t('asiakkaat.progress')} {step}/{totalSteps}
            </p>
            <BorderLinearProgress
              variant="determinate"
              value={progress}
              sx={{ marginBottom: 2, height: mobileView ? '17px' : '20px' }}
            />
          </Stack>
          {step === totalSteps - 1 && (
            <p
              style={{
                margin: '5px',
                fontSize: '12px',
                display: 'flex',
                justifyContent: 'flex-end'
              }}
            >
              {t('asiakkaat.progressAlmostDone')}
            </p>
          )}
        </div>
      )}
    </Translation>
  )
}

export default withStyles(styles)(MultiStepProgress)
